// ABOUTME: Screen 4A Make It Right: the card before the list exists, and Hold once it does, drawn as a veil layer over the finished impact scene.
// ABOUTME: Which one shows is read from the crossing alone (a Square with a Make It Right list is on Hold), so a reload or Back from 4B lands on the right one.

import { useMemo } from 'react';
import { useCrossingContent } from '../../../hooks/useCrossingContent';
import { CrossingTrigger } from '../../../types/api';
import type { ScreenProps, ScreenResult } from '../runner/screenContract';
import ImpactSkyMask from './impact/ImpactSkyMask';
import ReachTiles from './impact/ReachTiles';
import MakeItRightHold from './makeItRight/MakeItRightHold';
import {
  CARD_HEADLINE, CARD_SUB, HOLD_PLATE_HEADLINE, HOLD_PLATE_SUB, RESET_BUTTON,
} from './makeItRight/makeItRightCopy';

const CREATE_ACTION_ID = 'create_make_it_right_list';
const CONFIRM_ACTION_ID = 'we_made_it_right';

export default function Screen4A({ crossing, runner }: ScreenProps): ScreenResult {
  const { data: content } = useCrossingContent();
  const reachTypes = useMemo(() => Object.values(content?.reachTypes ?? {}), [content]);
  const isSquare = crossing.trigger === CrossingTrigger.Square;
  const hold = isSquare && crossing.makeItRightListId != null;

  if (hold) {
    // Hold owns its controls: the plate stays behind it, dimmed and inert, with neither action drawn.
    return {
      layer: <MakeItRightHold crossing={crossing} runner={runner} confirmActionId={CONFIRM_ACTION_ID} />,
      headline: HOLD_PLATE_HEADLINE,
      sub: HOLD_PLATE_SUB,
      plateDimmed: true,
      slots: { [CREATE_ACTION_ID]: { hidden: true }, [CONFIRM_ACTION_ID]: { hidden: true } },
    };
  }

  const selected = (crossing.reaches ?? []).map(reach => reach.reachCode);
  return {
    layer: <ImpactSkyMask still />,
    // The tiles are centred over the stack, so the cloud stack draws them, lit and not pressable.
    cloudTiers: { tiles: <ReachTiles reachTypes={reachTypes} selected={selected} readOnly /> },
    headline: CARD_HEADLINE,
    sub: CARD_SUB,
    // A Square draws Create; a Reset makes no list, so its one button is the repair confirmation under its own label.
    slots: isSquare
      ? { [CONFIRM_ACTION_ID]: { hidden: true } }
      : { [CREATE_ACTION_ID]: { hidden: true }, [CONFIRM_ACTION_ID]: { label: RESET_BUTTON } },
  };
}
